import { createAction, props } from '@ngrx/store';
import { SimXInstitution } from '../../../shared/models/entities/simx-institution.model';

export enum ActionTypes {
  CheckInstitutionListLoaded = '[Institution] Check Institution List Loaded',
  LoadInstitutionListRequested = '[Institution] Load Institution List Requested',
  LoadInstitutionListSucceeded = '[Institution] Load Institution List Succeeded',
  LoadInstitutionListFailed = '[Institution] Load Institution List Failed',
  LoadInstitutionList = '[Institution] Load Institution List',
  AddInstitutionToInstitutionList = '[Institution] Add Institution To Institution List',
  UpdateInstitutionInInstitutionList = '[Institution] Update Institution In Institution List',
  RemoveInstitutionFromInstitutionList = '[Institution] Remove Institution From Institution List',
  ResetInstitutionStore = '[Institution] Reset Institution Store',
  ResetInstitutionStoreAndLoadInstitutionList = '[Institution] Reset Institution Store And Load Institution List',
}

export const checkInstitutionListLoaded = createAction(
  ActionTypes.CheckInstitutionListLoaded,
);
export const loadInstitutionListRequested = createAction(
  ActionTypes.LoadInstitutionListRequested,
);
export const loadInstitutionListSucceeded = createAction(
  ActionTypes.LoadInstitutionListSucceeded,
  props<{ institutions: Array<SimXInstitution> }>(),
);
export const loadInstitutionListFailed = createAction(
  ActionTypes.LoadInstitutionListFailed,
  props<{ error: string }>(),
);
export const loadInstitutionList = createAction(
  ActionTypes.LoadInstitutionList,
  props<{ institutions: Array<SimXInstitution> }>(),
);
export const addInstitutionToInstitutionList = createAction(
  ActionTypes.AddInstitutionToInstitutionList,
  props<{ institution: SimXInstitution }>(),
);
export const updateInstitutionInInstitutionList = createAction(
  ActionTypes.UpdateInstitutionInInstitutionList,
  props<{ institution: SimXInstitution }>(),
);
export const removeInstitutionFromInstitutionList = createAction(
  ActionTypes.RemoveInstitutionFromInstitutionList,
  props<{ institutionId: string }>(),
);
export const resetInstitutionStore = createAction(
  ActionTypes.ResetInstitutionStore,
);
export const resetInstitutionStoreAndLoadInstitutionList = createAction(
  ActionTypes.ResetInstitutionStoreAndLoadInstitutionList,
);
